console.log("ver 1.05");

/**
 * для ограничений кол-ва нажатий на отправку форм, по умолчанию = false;
 */
var isStartSendForm = false;

window.addEventListener("load", (event) => {
  function validateEmail(mail) {
    const regEx =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return regEx.test(String(mail).toLowerCase());
  }

  var cur_width = $(window).width();

  $(window).resize(function () {
    if ($(window).width() <= 768 && cur_width > 768) {
      location.reload();
    } else if ($(window).width() > 768 && cur_width <= 768) {
      location.reload();
    }
  });

  $(window).resize(function () {
    if ($(window).width() <= 1199 && cur_width > 1199) {
      location.reload();
    } else if ($(window).width() > 1199 && cur_width <= 1199) {
      location.reload();
    }
  });

  window.addEventListener("orientationchange", (event) => {
    location.reload();
  });

  let dom = document.querySelector("html");

  let mqlDesktop = window.matchMedia("(min-width: 1200px)");
  let mqlTablet = window.matchMedia(
    "(min-width: 768px) and (max-width: 1199px)"
  );
  let mqlmobile = window.matchMedia("(min-width: 0px) and (max-width: 767px)");

  var isVertial;

  if (mqlDesktop.matches) {
    isVertial = false;
  } else {
    isVertial = true;
  }

  const scrollContainer = document.querySelector("html");

  let supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;

  if (supportsTouch) {
    let fl = false;

    let cord;
    let cordY;
    let cordDown;

    scrollContainer.addEventListener("mousedown", (evt) => {
      fl = true;
      cord = evt.clientX;
      cordY = evt.clientY;
      cordDown = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener("mouseup", (evt) => {
      fl = false;
    });

    scrollContainer.addEventListener("mousemove", (evt) => {
      if (fl) {
        evt.preventDefault();
        scrollContainer.scrollLeft =
          cordDown + cord - evt.clientX + cordY - evt.clientY;
        return false;
      }
    });
  }

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  if (mqlDesktop.matches) {
    const progressBar = function () {
      var winScroll =
        document.body.scrollLeft || document.documentElement.scrollLeft;
      var height =
        document.documentElement.scrollWidth -
        document.documentElement.clientWidth;
      var scrolled = (winScroll / height) * 100;
      document.querySelector(".js-progress").style.width = scrolled + "%";
    };
    if (document.querySelector(".js-progress")) {
      window.onscroll = function () {
        progressBar();
      };
    }
  }

  if (document.querySelector(".header")) {
    const menuBtn = document.querySelector(".js-menu-btn");
    const openSearchBtn = document.querySelector(".js-open-search");
    const searchForm = document.querySelector(".js-search-form");
    const menu = document.querySelector(".js-menu");
    const head = document.querySelector(".js-head");

    menuBtn.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("active");
      dom.classList.toggle("disabled");

      $(menu).slideToggle("slow", function () {
        head.classList.toggle("active");
      });
    });

    openSearchBtn.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("active");
      searchForm.classList.toggle("active");
    });

    if (document.querySelector("main")) {
      document.querySelector("main").addEventListener("click", () => {
        if (head.classList.contains("active")) {
          dom.classList.toggle("disabled");
          menuBtn.classList.toggle("active");

          $(menu).slideToggle("slow", function () {
            head.classList.toggle("active");
          });
        }
      });
    }

    if (document.querySelector("footer")) {
      document.querySelector("footer").addEventListener("click", () => {
        if (head.classList.contains("active")) {
          dom.classList.toggle("disabled");
          menuBtn.classList.toggle("active");

          $(menu).slideToggle("slow", function () {
            head.classList.toggle("active");
          });
        }
      });
    }
  }

  // if (mqlDesktop.matches) {

  //   var BrowserDetect = {
  //     init: function () {
  //       this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
  //       this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
  //       this.OS = this.searchString(this.dataOS) || "an unknown OS";
  //     },
  //     searchString: function (data) {
  //       for (var i = 0; i < data.length; i++) {
  //         var dataString = data[i].string;
  //         var dataProp = data[i].prop;
  //         this.versionSearchString = data[i].versionSearch || data[i].identity;
  //         if (dataString) {
  //           if (dataString.indexOf(data[i].subString) != -1)
  //             return data[i].identity;
  //         } else if (dataProp)
  //           return data[i].identity;
  //       }
  //     },
  //     searchVersion: function (dataString) {
  //       var index = dataString.indexOf(this.versionSearchString);
  //       if (index == -1) return;
  //       return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
  //     },
  //     dataBrowser: [{
  //         string: navigator.userAgent,
  //         subString: "Chrome",
  //         identity: "Chrome"
  //       },
  //       {
  //         string: navigator.userAgent,
  //         subString: "OmniWeb",
  //         versionSearch: "OmniWeb/",
  //         identity: "OmniWeb"
  //       },
  //       {
  //         string: navigator.vendor,
  //         subString: "Apple",
  //         identity: "Safari",
  //         versionSearch: "Version"
  //       },
  //       {
  //         prop: window.opera,
  //         identity: "Opera",
  //         versionSearch: "Version"
  //       },
  //       {
  //         string: navigator.vendor,
  //         subString: "iCab",
  //         identity: "iCab"
  //       },
  //       {
  //         string: navigator.vendor,
  //         subString: "KDE",
  //         identity: "Konqueror"
  //       },
  //       {
  //         string: navigator.userAgent,
  //         subString: "Firefox",
  //         identity: "Firefox"
  //       },
  //       {
  //         string: navigator.vendor,
  //         subString: "Camino",
  //         identity: "Camino"
  //       },
  //       {
  //         /* For Newer Netscapes (6+) */
  //         string: navigator.userAgent,
  //         subString: "Netscape",
  //         identity: "Netscape"
  //       },
  //       {
  //         string: navigator.userAgent,
  //         subString: "MSIE",
  //         identity: "Internet Explorer",
  //         versionSearch: "MSIE"
  //       },
  //       {
  //         string: navigator.userAgent,
  //         subString: "Gecko",
  //         identity: "Mozilla",
  //         versionSearch: "rv"
  //       },
  //       {
  //         /* For Older Netscapes (4-) */
  //         string: navigator.userAgent,
  //         subString: "Mozilla",
  //         identity: "Netscape",
  //         versionSearch: "Mozilla"
  //       }
  //     ],
  //     dataOS: [{
  //         string: navigator.platform,
  //         subString: "Win",
  //         identity: "Windows"
  //       },
  //       {
  //         string: navigator.platform,
  //         subString: "Mac",
  //         identity: "Mac"
  //       },
  //       {
  //         string: navigator.userAgent,
  //         subString: "iPhone",
  //         identity: "iPhone/iPod"
  //       },
  //       {
  //         string: navigator.platform,
  //         subString: "Linux",
  //         identity: "Linux"
  //       }
  //     ]

  //   };

  //   BrowserDetect.init();

  //   if (BrowserDetect.browser === 'Firefox') {
  //     if (document.querySelector('body.container').classList.contains('vertical')) {} else {
  //       scrollContainer.addEventListener(
  //         "wheel",
  //         (evt) => {
  //           evt.preventDefault();
  //           document.activeElement.blur();

  //           scrollContainer.scrollLeft += evt.deltaY / 2;
  //         }, {
  //           passive: false
  //         },
  //       );
  //     };

  //   } else {
  //     $(window).on('mousewheel', function (e) {
  //       let dir,
  //         amt = 400;
  //       e.preventDefault();

  //       document.activeElement.blur();

  //       if (e.type === 'mousewheel') {
  //         dir = e.originalEvent.wheelDelta > 0 ? '-=' : '+=';
  //       } else {
  //         dir = e.originalEvent.detail < 0 ? '-=' : '+=';
  //       }

  //       $(scrollContainer).stop().animate({
  //         scrollLeft: dir + amt
  //       }, 500, 'linear');
  //     })
  //   }
  // }

  if (document.querySelector("body.container").classList.contains("vertical")) {
  } else {
    if (mqlDesktop.matches) {
      scrollContainer.addEventListener(
        "wheel",
        (evt) => {
          evt.preventDefault();
          document.activeElement.blur();

          scrollContainer.scrollLeft += evt.deltaY / 2;
        },
        {
          passive: false,
        }
      );
    }
  }

  if (document.querySelector(".home-main")) {
    new Swiper(".home-main__swiper", {
      pagination: {
        el: ".home-main__pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3500,
      },
    });
  }

  if (document.querySelector(".decor-arrow")) {
    new Swiper(".decor-arrow__swiper", {
      slidesPerView: 5,
      spaceBetween: 30,
      speed: 1500,
      loopedSlides: 5,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          direction: "horizontal",
          autoplay: {
            reverseDirection: true,
          },
        },
        1200: {
          direction: "vertical",
          autoplay: {
            reverseDirection: false,
          },
        },
      },
    });
  }

  if (document.querySelector(".js-shape-bar")) {
    const barLink = document.querySelector(".js-bar-link");
    const barVideo = document.querySelector(".js-bar-video");

    if (barLink) {
    }

    const setBarVariables = function () {
      if (mqlDesktop.matches) {
        var shapeRect = document
          .querySelector(".js-shape.desktop")
          .getBoundingClientRect();
        var shapeLinkRect = document
          .querySelector(".js-shape-link.desktop")
          .getBoundingClientRect();
        var shapeVideoRect = document
          .querySelector(".js-shape-video.desktop")
          .getBoundingClientRect();
      }

      if (mqlTablet.matches) {
        var shapeRect = document
          .querySelector(".js-shape.tablet")
          .getBoundingClientRect();
        var shapeLinkRect = document
          .querySelector(".js-shape-link.tablet")
          .getBoundingClientRect();
        var shapeVideoRect = document
          .querySelector(".js-shape-video.tablet")
          .getBoundingClientRect();
      }

      if (mqlmobile.matches) {
        var shapeRect = document
          .querySelector(".js-shape.mobile")
          .getBoundingClientRect();
        var shapeLinkRect = document
          .querySelector(".js-shape-link.mobile")
          .getBoundingClientRect();
        var shapeVideoRect = document
          .querySelector(".js-shape-video.mobile")
          .getBoundingClientRect();
      }

      barLink.style.width = `${shapeLinkRect.width}px`;
      barLink.style.height = `${shapeLinkRect.height}px`;

      if (mqlDesktop.matches) {
        barLink.style.top = `${shapeLinkRect.top}px`;
        barLink.style.left = `${shapeLinkRect.left - shapeRect.left}px`;
      }

      if (mqlTablet.matches) {
        barLink.style.top = `${shapeLinkRect.top - shapeRect.top}px`;
        barLink.style.left = `${shapeLinkRect.left - shapeRect.left + 30}px`;
      }

      if (mqlmobile.matches) {
        barLink.style.top = `${shapeLinkRect.top - shapeRect.top}px`;
        barLink.style.left = `${shapeLinkRect.left - shapeRect.left + 8}px`;
      }

      barVideo.style.width = `${shapeVideoRect.width}px`;
      barVideo.style.height = `${shapeVideoRect.height}px`;
      if (mqlDesktop.matches) {
        barVideo.style.top = `${shapeVideoRect.top}px`;
        barVideo.style.left = `${shapeVideoRect.left - shapeRect.left}px`;
      }

      if (mqlTablet.matches) {
        barVideo.style.top = `${shapeVideoRect.top - shapeRect.top}px`;
        barVideo.style.left = `${shapeVideoRect.left - shapeRect.left + 30}px`;
      }

      if (mqlmobile.matches) {
        barVideo.style.top = `${shapeVideoRect.top - shapeRect.top}px`;
        barVideo.style.left = `${shapeVideoRect.left - shapeRect.left + 8}px`;
      }
    };

    const shapeBar = document.querySelector(".js-shape-bar");

    if (mqlDesktop.matches) {
      var shapers = document.querySelectorAll(".js-shaper.desktop");
    }

    if (mqlTablet.matches) {
      var shapers = document.querySelectorAll(".js-shaper.tablet");
    }

    if (mqlmobile.matches) {
      var shapers = document.querySelectorAll(".js-shaper.mobile");
    }

    const setShaperVariables = function () {
      shapers.forEach((item, i) => {
        if (mqlDesktop.matches) {
          var shapeRect = document
            .querySelector(".js-shape.desktop")
            .getBoundingClientRect();
        }

        if (mqlTablet.matches) {
          var shapeRect = document
            .querySelector(".js-shape.tablet")
            .getBoundingClientRect();
        }

        if (mqlmobile.matches) {
          var shapeRect = document
            .querySelector(".js-shape.mobile")
            .getBoundingClientRect();
        }

        let innerDiv = document.createElement("div");
        if (mqlDesktop.matches) {
          innerDiv.className = "shaper desktop";
        }

        if (mqlTablet.matches) {
          innerDiv.className = "shaper tablet";
        }

        if (mqlmobile.matches) {
          innerDiv.className = "shaper mobile";
        }

        shapeBar.appendChild(innerDiv);

        let itemRect = item.getBoundingClientRect();

        innerDiv.style.width = `${itemRect.width + 2}px`;
        innerDiv.style.height = `${itemRect.height - 50}px`;
        if (mqlDesktop.matches) {
          innerDiv.style.top = `${itemRect.top - 1}px`;
          innerDiv.style.left = `${itemRect.left - shapeRect.left - 1}px`;
        }

        if (mqlTablet.matches) {
          innerDiv.style.top = `${itemRect.top - shapeRect.top - 1}px`;
          innerDiv.style.left = `${itemRect.left - shapeRect.left - 1 + 30}px`;
        }

        if (mqlmobile.matches) {
          innerDiv.style.top = `${itemRect.top - shapeRect.top - 1}px`;
          innerDiv.style.left = `${itemRect.left - shapeRect.left - 1 + 8}px`;
        }

        let controller = new ScrollMagic.Controller({
          vertical: isVertial,
        });

        // build tween
        var tween = TweenMax.to(innerDiv, 0.5, {
          height: 0,
          // className: 'active',
        });

        // build scene
        var scene = new ScrollMagic.Scene({
          triggerElement: innerDiv,
          duration: 300,
          triggerHook: 0.7,
        })
          .setTween(tween)
          // .addIndicators() // add indicators (requires plugin)
          .addTo(controller);
      });
    };

    const changeShapersVariables = function () {
      if (mqlDesktop.matches) {
        var shapersInner = document.querySelectorAll(".shaper.desktop");
        var shapers = document.querySelectorAll(".js-shaper.desktop");
        var shapeRect = document
          .querySelector(".js-shape.desktop")
          .getBoundingClientRect();
      }
      if (mqlTablet.matches) {
        var shapersInner = document.querySelectorAll(".shaper.tablet");
        var shapers = document.querySelectorAll(".js-shaper.tablet");
        var shapeRect = document
          .querySelector(".js-shape.tablet")
          .getBoundingClientRect();
      }

      if (mqlmobile.matches) {
        var shapersInner = document.querySelectorAll(".shaper.mobile");
        var shapers = document.querySelectorAll(".js-shaper.mobile");
        var shapeRect = document
          .querySelector(".js-shape.mobile")
          .getBoundingClientRect();
      }

      shapers.forEach((item, i) => {
        let itemRect = item.getBoundingClientRect();
        shapersInner[i].style.width = `${itemRect.width + 2}px`;
        if (mqlDesktop.matches) {
          shapersInner[i].style.top = `${itemRect.top - 1}px`;
          shapersInner[i].style.left = `${
            itemRect.left - shapeRect.left - 1
          }px`;
        }
        if (mqlTablet.matches) {
          shapersInner[i].style.top = `${itemRect.top - shapeRect.top - 1}px`;
          shapersInner[i].style.left = `${
            itemRect.left - shapeRect.left - 1 + 30
          }px`;
        }

        if (mqlmobile.matches) {
          shapersInner[i].style.top = `${itemRect.top - shapeRect.top - 1}px`;
          shapersInner[i].style.left = `${
            itemRect.left - shapeRect.left - 1 + 8
          }px`;
        }
      });
    };

    setTimeout(() => {
      if (barLink) {
        setBarVariables();
      }

      setShaperVariables();
    }, 100);

    window.addEventListener("resize", (event) => {
      if (barLink) {
        setBarVariables();
      }
      changeShapersVariables();
    });
  }

  if (document.querySelector(".home-about")) {
    if (document.querySelector(".js-table")) {
      let controller = new ScrollMagic.Controller({
        vertical: isVertial,
      });
      // build tween
      var tween = TweenMax.to(".js-table", 0.5, {
        className: "+=show",
      });

      // build scene
      var scene = new ScrollMagic.Scene({
        triggerElement: ".js-table",
        duration: $(".js-table").width(),
        triggerHook: 0.7,
      })
        .setTween(tween)
        //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
  }

  if (document.querySelector(".js-elem-preview")) {
    const previewElements = document.querySelectorAll(".js-elem-preview");

    previewElements.forEach((item, i) => {
      let innerSpan = document.createElement("span");
      innerSpan.className = "plug";
      innerSpan.style.background = item.getAttribute("data-bg");
      item.appendChild(innerSpan);

      let controller = new ScrollMagic.Controller({
        vertical: isVertial,
      });

      var tween = TweenMax.to(item, 0.5, {
        className: "+=show",
      });

      var scene = new ScrollMagic.Scene({
        triggerElement: item,
        duration: $(item).width(),
        triggerHook: 0.7,
      })
        .setTween(tween)
        //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    });
  }

  if (document.querySelector(".home-suggestions")) {
    new Swiper(".companys__swiper.first", {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 16000,
      loopedSlides: 1,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          direction: "horizontal",
        },
        1200: {
          direction: "vertical",
        },
      },
    });
    new Swiper(".companys__swiper.second", {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 8000,
      loopedSlides: 1,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          direction: "horizontal",
        },
        1200: {
          direction: "vertical",
        },
      },
    });
    new Swiper(".companys__swiper.thrid", {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 16000,
      loopedSlides: 1,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          direction: "horizontal",
        },
        1200: {
          direction: "vertical",
        },
      },
    });
  }

  if (document.querySelector(".home-team")) {
    var swiperTeam = new Swiper(".home-team__swiper", {
      spaceBetween: 30,
      effect: "fade",
      // loop: true,
      allowTouchMove: false,
      noSwiping: true,
      navigation: {
        nextEl: ".home-team__next",
        prevEl: ".home-team__prev",
      },
      pagination: {
        el: ".home-team__pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          direction: "horizontal",
          allowTouchMove: true,
          noSwiping: false,
        },
        768: {
          direction: "horizontal",
          allowTouchMove: false,
          noSwiping: true,
        },
        1200: {
          direction: "vertical",
          allowTouchMove: false,
          noSwiping: true,
        },
      },
    });
  }

  if (document.querySelector(".home-app")) {
    if (mqlDesktop.matches) {
      function debounce(func, wait, immediate) {
        let timeout;
        return function () {
          let context = this,
            args = arguments;
          let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          let callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }

      const appsList = document.querySelector(".js-apps");

      let isPlay = false;

      let homeAppSwiper = new Swiper(".home-app__swiper", {
        slidesPerView: 4,
        spaceBetween: 10,
        speed: 500,
        loopedSlides: 4,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        },
        breakpoints: {
          0: {
            direction: "horizontal",
          },
          1200: {
            direction: "vertical",
          },
        },
      });

      homeAppSwiper.autoplay.stop();

      function debounceEvent(func, wait, immediate) {
        let timeout;
        return function () {
          let context = this,
            args = arguments;
          let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          let callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }

      appsList.addEventListener("mouseenter", (e) => {
        e.preventDefault();
        const storageEventCbStart = () => homeAppSwiper.autoplay.start();
        const debouncedCbStart = debounceEvent(storageEventCbStart, 300);
        debouncedCbStart();
      });

      appsList.addEventListener("mouseleave", (e) => {
        e.preventDefault();
        const storageEventCbStop = () => homeAppSwiper.autoplay.stop();
        const debouncedCbStop = debounceEvent(storageEventCbStop, 300);
        debouncedCbStop();
      });
    }
  }

  if (document.querySelector(".footer")) {
    let homeAppSwiper = new Swiper(".footer__swiper", {
      speed: 7000,
      loop: true,
      allowTouchMove: false,
      loopedSlides: 2,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 65,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    });
  }

  if (document.querySelector(".decor-fm")) {
    let controller = new ScrollMagic.Controller({
      vertical: isVertial,
    });

    if (mqlDesktop.matches) {
      // build tween
      let tween = new TimelineMax().add([
        TweenMax.fromTo(
          ".decor-fm ul",
          1,
          {
            y: "100%",
          },
          {
            y: "-100%",
            ease: Linear.easeIn,
          }
        ),
      ]);

      // build scene
      let scene = new ScrollMagic.Scene({
        triggerHook: 1,
        triggerElement: ".companys",

        //// WARNING: указать предыдущую секцию без класса.
        duration: $(".home-projects").width(),
      })
        .setTween(tween)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
    if (mqlTablet.matches) {
      // build tween
      let tween = new TimelineMax().add([
        TweenMax.fromTo(
          ".decor-fm ul",
          1,
          {
            x: "0",
          },
          {
            x: "-100%",
            ease: Linear.easeIn,
          }
        ),
      ]);

      // build scene
      let scene = new ScrollMagic.Scene({
        triggerHook: 1,
        triggerElement: ".decor-fm ul",

        //// WARNING: указать предыдущую секцию без класса.
        duration: $(window).height() * 2,
      })
        .setTween(tween)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }

    if (mqlmobile.matches) {
      // build tween
      let tween = new TimelineMax().add([
        TweenMax.fromTo(
          ".decor-fm ul",
          1,
          {
            x: "0",
          },
          {
            x: "-100%",
            ease: Linear.easeIn,
          }
        ),
      ]);

      // build scene
      let scene = new ScrollMagic.Scene({
        triggerHook: 1,
        triggerElement: ".decor-fm ul",

        //// WARNING: указать предыдущую секцию без класса.
        duration: $(window).height() * 2,
      })
        .setTween(tween)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
  }

  if (document.querySelector(".home-advantages")) {
    if (mqlDesktop.matches) {
      let controller = new ScrollMagic.Controller({
        vertical: isVertial,
      });
      // build tween
      let tween = new TimelineMax().add([
        TweenMax.fromTo(
          ".home-main",
          1,
          {
            x: "0",
          },
          {
            x: "100%",
          }
        ),
      ]);

      // build scene
      let scene = new ScrollMagic.Scene({
        triggerHook: 0.5,
        triggerElement: ".home-advantages",
        duration: $(".home-main").width() * 2,
      })
        .setTween(tween)
        //   .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
    }
  }

  if (document.querySelector(".js-column-titles")) {
    let controller = new ScrollMagic.Controller({
      vertical: isVertial,
    });
    // build tween
    var tween = TweenMax.to(".js-column-titles", 0.5, {
      className: "+=show",
    });

    // build scene
    var scene = new ScrollMagic.Scene({
      triggerElement: ".js-column-titles",
      duration: $(".js-column-titles").width(),
      triggerHook: 0.7,
    })
      .setTween(tween)
      //   .addIndicators() // add indicators (requires plugin)
      .addTo(controller);
  }

  if (document.querySelector(".js-swipes")) {
    // init controller
    document.querySelectorAll(".js-swipes li").forEach((item, i) => {
      let controller = new ScrollMagic.Controller({
        vertical: isVertial,
      });

      if (mqlDesktop.matches) {
        // build tween
        var tween = TweenMax.to(item, 0.5, {
          width: "1075px",
          className: "active",
        });

        // build scene
        var scene = new ScrollMagic.Scene({
          triggerElement: item,
          duration: 300,
          triggerHook: 0.3,
        })
          .setTween(tween)
          //   .addIndicators() // add indicators (requires plugin)
          .addTo(controller);
      } else {
        // build tween
        var tween = TweenMax.to(item, 0.5, {
          className: "show",
        });

        // build scene
        var scene = new ScrollMagic.Scene({
          triggerElement: item,
          duration: 300,
          triggerHook: 0.6,
        })
          .setTween(tween)
          // .addIndicators() // add indicators (requires plugin)
          .addTo(controller);
      }
    });
  }

  if (document.querySelector(".home-projects")) {
    const projectsLists = document.querySelectorAll(".js-projects");

    if (mqlDesktop.matches) {
      projectsLists.forEach((item, i) => {
        let controller = new ScrollMagic.Controller({
          vertical: isVertial,
        });

        if (item.classList.contains("first")) {
          // build tween
          let tween = new TimelineMax().add([
            TweenMax.fromTo(
              item,
              1,
              {
                x: -$(window).width() / 2,
              },
              {
                x: "0",
              }
            ),
          ]);

          // build scene
          let scene = new ScrollMagic.Scene({
            triggerHook: 1,
            triggerElement: ".home-projects",
            duration: $(window).width(),
          })
            .setTween(tween)
            //   .addIndicators() // add indicators (requires plugin)
            .addTo(controller);
        }
        if (item.classList.contains("second")) {
          // build tween
          let tween = new TimelineMax().add([
            TweenMax.fromTo(
              item,
              1,
              {
                x: $(window).width() / 2,
              },
              {
                x: "0",
              }
            ),
          ]);

          // build scene
          let scene = new ScrollMagic.Scene({
            triggerHook: 1,
            triggerElement: ".home-projects",
            duration: $(window).width(),
          })
            .setTween(tween)
            //   .addIndicators() // add indicators (requires plugin)
            .addTo(controller);
        }
        if (item.classList.contains("thrid")) {
          // build tween
          let tween = new TimelineMax().add([
            TweenMax.fromTo(
              item,
              1,
              {
                x: -$(window).width(),
              },
              {
                x: "0",
              }
            ),
          ]);

          // build scene
          let scene = new ScrollMagic.Scene({
            triggerHook: 1,
            triggerElement: ".home-projects",
            duration: $(window).width(),
          })
            .setTween(tween)
            //   .addIndicators() // add indicators (requires plugin)
            .addTo(controller);
        }
      });
    } else {
      Scrollbar.init(document.querySelector(".js-scrollbar"), {
        overscrollEffect: "bounce",
        alwaysShowTracks: true,
      });

      document.querySelectorAll(".js-desktop-link").forEach((item, i) => {
        item.addEventListener("click", function (e) {
          e.preventDefault();
        });
      });

      document
        .querySelectorAll(".js-projects-content li")
        .forEach((item, i) => {
          item.addEventListener("mouseenter", (e) => {
            e.preventDefault();
            setTimeout(() => {
              item.classList.add("active");
            }, 500);
          });
        });

      document
        .querySelectorAll(".js-projects-content li")
        .forEach((item, i) => {
          item.addEventListener("mouseleave", (e) => {
            e.preventDefault();
            setTimeout(() => {
              item.classList.remove("active");
            }, 500);
          });
        });
    }
  }

  if (document.querySelector(".company-services")) {
    new Swiper(".company-services__swiper", {
      spaceBetween: 10,
      speed: 500,
      loopedSlides: 3,
      loop: true,
      autoplay: {
        delay: 2500,
      },
      pagination: {
        el: ".company-services__pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3,
        },
      },
    });
  }

  if (document.querySelector(".marquee-horizontal__swiper")) {
    new Swiper(".marquee-horizontal__swiper", {
      slidesPerView: 5,
      spaceBetween: 30,
      speed: 3000,
      loopedSlides: 5,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      // breakpoints: {
      //   0: {
      //     direction: "horizontal",
      //     autoplay: {
      //       reverseDirection: true,
      //     },
      //   },
      //   1200: {
      //     direction: "vertical",
      //     autoplay: {
      //       reverseDirection: false,
      //     },
      //   },
      // },
    });
  }

  if (document.querySelector(".company-history")) {
    let historyMain = new Swiper(".company-history__swiper-main", {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      // loopedSlides: 1,
      // loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
    });

    var historyPagination = new Swiper(".company-history__swiper-pagination", {
      spaceBetween: 10,
      speed: 500,
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: ".company-history__swiper-pagination-next",
        prevEl: ".company-history__swiper-pagination-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
          loopedSlides: 3,
        },
        768: {
          slidesPerView: 5,
          loopedSlides: 5,
        },
      },
    });

    historyMain.on("slideChangeTransitionEnd", function () {
      let index_currentSlide = historyMain.realIndex;
      let currentSlide = historyMain.slides[index_currentSlide];
      historyPagination.slideTo(index_currentSlide, 1000, false);
    });

    historyPagination.on("slideChangeTransitionEnd", function () {
      let index_currentSlide = historyPagination.realIndex;
      let currentSlide = historyPagination.slides[index_currentSlide];
      historyMain.slideTo(index_currentSlide, 1000, false);
    });
  }

  if (document.querySelector(".js-gallery")) {
    $(".js-gallery").lightGallery();

    if (mqlTablet.matches) {
      Scrollbar.init(document.querySelector(".js-gallery-scrollbar"), {
        overscrollEffect: "bounce",
        alwaysShowTracks: true,
      });
    }
    if (mqlmobile.matches) {
      Scrollbar.init(document.querySelector(".js-gallery-scrollbar"), {
        overscrollEffect: "bounce",
        alwaysShowTracks: true,
      });
    }
  }

  $(".js-popup-youtube, .js-popup-maps").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,

    fixedContentPos: true,
  });

  $(".js-popup-video").magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
  });

  if (document.querySelector(".news")) {
    const itemList = document.querySelector(".news__list");
    const moreBtn = document.querySelector(".js-more");

    if (mqlDesktop.matches) {
      let count = document.querySelectorAll(".news__list li").length / 2;
      itemList.setAttribute(
        "style",
        `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`
      );
    }

    moreBtn.addEventListener("click", function (e) {
      e.preventDefault();
      // warning - заменить на ajax

      if (typeof showMoreNewsList === "function") {
        showMoreNewsList(moreBtn, itemList);
      } else {
        // itemList.insertAdjacentHTML(
        //   "beforeend",
        //   `<li>
				// 		  <div class="img">
				// 			<picture>
				// 			  <source srcset="img/mock.webp" type="image/webp">
				// 			  <img src="img/mock.jpg" alt="picture">
				// 			</picture>
				// 			<time datetime="1997-08-13">13/08/1997</time>
				// 		  </div>
				// 		  <a href="javascript:void(0)">Becar asset managment приступила...</a>
				// 		  <p>Becar приступила к обслуживанию недвижимости АО «Мерседес-Бенц РУС».</p>
				// 		</li>`
        // );
      }
        // if (mqlDesktop.matches) {
        //   console.log('desktop main');
        //   let count = document.querySelectorAll('.news__list li').length / 2;
        //   itemList.setAttribute('style', `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`);
        // }
    });

    const years = document.querySelectorAll(".js-year");
    const unactive = document.querySelectorAll(".js-unactive");

    years.forEach((item, i) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        this.closest("li").classList.add("active");
      });
    });

    unactive.forEach((item, i) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.closest("li").classList.remove("active");
      });
    });
  }

  if (document.querySelector(".cases")) {
    const parent = document.querySelector(".cases");
    const items = parent.querySelectorAll(".js-item");

    const hiddenDirections = document.querySelector(".js-directions");
    const hiddenType = document.querySelector(".js-type");

    items.forEach((element) => {
      let hideBlock = element.querySelector(".options");
      element.querySelector(".js-select").addEventListener("click", (e) => {
        e.preventDefault();
        $(hideBlock).slideToggle("fast", function () {
          element.classList.toggle("active");
        });
      });
      if (hideBlock.classList.contains("js-options-directions")) {
        let options = hideBlock.querySelectorAll("a");
        options.forEach((el) => {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            element.closest(".js-item").querySelector("span").innerHTML =
              el.innerHTML;
            hiddenDirections.value = el.getAttribute("data-value");
            $(hideBlock).slideToggle("fast", function () {
              element.classList.toggle("active");
            });
          });
        });
      }
      if (hideBlock.classList.contains("js-options-type")) {
        let options = hideBlock.querySelectorAll("a");
        options.forEach((el) => {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            element.closest(".js-item").querySelector("span").innerHTML =
              el.innerHTML;
            hiddenType.value = el.getAttribute("data-value");
            $(hideBlock).slideToggle("fast", function () {
              element.classList.toggle("active");
            });
          });
        });
      }
    });

    const accordionBtns = document.querySelectorAll(".js-toggle");
    const hideBlocks = document.querySelectorAll(".js-accordion");

    accordionBtns.forEach((el, idx) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        $(hideBlocks[idx]).slideToggle("slow", function () {
          // cb
        });
        this.closest(".item").classList.toggle("active");
        this.classList.toggle("active");
      });
    });

    const moreBtn = document.querySelector(".js-more");

    moreBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (typeof showMoreTeamList === "function") {
        showMoreTeamList(moreBtn, list);
      } else {
        list.insertAdjacentHTML("beforeend", testTemplateItem);
      }
    });

  }






  if (document.querySelector("section.team")) {
    // warning - заменить на ajax
    const testTemplateItem = `
    <li>
    <div class="img">
        <picture>
            <source srcset="img/expert-img.webp" type="image/webp">
            <img src="img/expert-img.jpg" alt="picture">
        </picture>
        <svg xmlns="http://www.w3.org/2000/svg" width="437" height="456"
            preserveAspectRatio="none" viewBox="0 0 437 456" fill="none">
            <rect x="374" width="63" height="63" fill="#333333" />
            <rect x="43" y="456" width="43" height="43" transform="rotate(180 43 456)"
                fill="#059BAA" />
            <rect x="344" y="63" width="30" height="30" fill="#333333" />
            <rect x="63" y="413" width="20" height="20" transform="rotate(180 63 413)"
                fill="#059BAA" />
            <rect x="44" y="63" width="38" height="38" fill="#333333" />
            <rect x="368" y="179" width="18" height="18" fill="#059BAA" />
        </svg>
    </div>
    <div class="info">
        <p class="name">Дмитрий Тищенко</p>
        <!-- WARNING max 82 -->
        <p class="post">Директор по непрофильным активам</p>
        <!-- WARNING max 297 -->
        <p class="description">Небольшой текст о эксперте</p>
    </div>
</li>`;

    const list = document.querySelector(".js-team-list");
    const moreBtn = document.querySelector(".js-item-more");

    moreBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (typeof showMoreTeamList === "function") {
        showMoreTeamList(moreBtn, list);
      } else {
        list.insertAdjacentHTML("beforeend", testTemplateItem);
      }
    });
  }

  if (document.querySelector("section.gallery")) {
    // заменить на ajax

    const galleryList = document.querySelector(".js-gl");
    const moreBtn = document.querySelector(".js-more");

    const template = `
    <a href="http://dummyimage.com/1366x768/99cccc.jpeg">
    <img src="http://dummyimage.com/1366x768/99cccc.jpeg" alt="img"/>
    </a>
    <a href="http://dummyimage.com/1366x768/99cccc.jpeg">
    <img src="http://dummyimage.com/1366x768/99cccc.jpeg" alt="img"/>
    </a>
    `;

    $(galleryList).lightGallery();

    moreBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (typeof showMoreGallery === "function") {
        await showMoreGallery(moreBtn, galleryList);
        reInitList();
      } else {
        galleryList.insertAdjacentHTML("beforeend", template);
        reInitList();
        // var lg = jQuery('.js-gl');
        // lg.data('lightGallery').destroy(true);
        // $(galleryList).lightGallery();

        // if (mqlDesktop.matches) {
        // 	let count = document.querySelectorAll('.js-gl a').length / 2;
        // 	galleryList.setAttribute('style', `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`);
        // }
      }
    });

    /**
     * инициализация галереи ..
     */
    function reInitList() {
      var lg = jQuery(".js-gl");
      lg.data("lightGallery").destroy(true);
      $(galleryList).lightGallery();
      if (mqlDesktop.matches) {
        let count = document.querySelectorAll(".js-gl a").length / 2;
        galleryList.setAttribute(
          "style",
          `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`
        );
      }
    }
  }

  if (document.querySelector(".geography")) {
    const initScrolls = function () {
      let geographyList = document.querySelectorAll(".js-list .item");
      document.querySelectorAll(".js-scrollbar").forEach((elem) => {
        Scrollbar.init(elem, {
          overscrollEffect: "bounce",
          alwaysShowTracks: true,
        });
      });

      geographyList.forEach((el) => {
        let list = el.querySelector(".js-scrollbar");
        if (el.querySelectorAll(".js-scrollbar li").length > 4) {
          list.querySelector(".scrollbar-track-y").style.visibility = "visible";
        }
      });
    };

    initScrolls();

    $(".js-popup-geography").magnificPopup({
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,

      fixedContentPos: true,
    });

    // заменить на ajax

    const template = `
    <li class="item">
    <div class="info">
        <picture>
            <source srcset="img/geography-company1.webp" type="image/webp">
            <img src="img/geography-company1.png" alt="picture">
        </picture>
        <h3>ОАО “Газпром”</h3>
            <p>Работа с <span>2004</span> г.</p>
            <p>Сделано <span>500+</span> проектов</p>
    </div>
    <div class="prod">
        <p class="title">Проекты которые сделали вместе</p>
        <ul class="js-scrollbar">
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>


        </ul>
        <a class="map js-popup-geography" href="https://yandex.ru/map-widget/v1/-/CCUReQGZ-A">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                viewBox="0 0 30 30" fill="none">
                <path
                    d="M26.1911 12.2498C26.1911 20.6914 15.3377 27.9269 15.3377 27.9269C15.3377 27.9269 4.48438 20.6914 4.48438 12.2498C4.48438 9.37136 5.62785 6.61076 7.66325 4.57536C9.69865 2.53996 12.4592 1.39648 15.3377 1.39648C18.2162 1.39648 20.9768 2.53996 23.0122 4.57536C25.0476 6.61076 26.1911 9.37136 26.1911 12.2498Z"
                    fill="white" />
                <path
                    d="M15.3365 15.8684C17.3346 15.8684 18.9543 14.2487 18.9543 12.2506C18.9543 10.2526 17.3346 8.63281 15.3365 8.63281C13.3385 8.63281 11.7188 10.2526 11.7188 12.2506C11.7188 14.2487 13.3385 15.8684 15.3365 15.8684Z"
                    fill="#059BAA" />
            </svg>
        </a>
    </div>
</li>
<li class="item">
    <div class="info">
        <picture>
            <source srcset="img/geography-company1.webp" type="image/webp">
            <img src="img/geography-company1.png" alt="picture">
        </picture>
        <h3>ОАО “Газпром”</h3>
            <p>Работа с <span>2004</span> г.</p>
            <p>Сделано <span>500+</span> проектов</p>
    </div>js-more
    <div class="prod">
        <p class="title">Проекты которые сделали вместе</p>
        <ul class="js-scrollbar">
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>

            <li>
                <a href="javascript:void(0)">Ссылка на работу</a>
            </li>
        </ul>
        <a class="map js-popup-geography" href="https://yandex.ru/map-widget/v1/-/CCUReQGZ-A">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                viewBox="0 0 30 30" fill="none">
                <path
                    d="M26.1911 12.2498C26.1911 20.6914 15.3377 27.9269 15.3377 27.9269C15.3377 27.9269 4.48438 20.6914 4.48438 12.2498C4.48438 9.37136 5.62785 6.61076 7.66325 4.57536C9.69865 2.53996 12.4592 1.39648 15.3377 1.39648C18.2162 1.39648 20.9768 2.53996 23.0122 4.57536C25.0476 6.61076 26.1911 9.37136 26.1911 12.2498Z"
                    fill="white" />
                <path
                    d="M15.3365 15.8684C17.3346 15.8684 18.9543 14.2487 18.9543 12.2506C18.9543 10.2526 17.3346 8.63281 15.3365 8.63281C13.3385 8.63281 11.7188 10.2526 11.7188 12.2506C11.7188 14.2487 13.3385 15.8684 15.3365 15.8684Z"
                    fill="#059BAA" />
            </svg>
        </a>
    </div>
</li>
    `;

    const moreBtn = document.querySelector(".js-more");
    const frList = document.querySelector(".js-list");
    if (moreBtn)
      moreBtn.addEventListener("click", function (e) {
        e.preventDefault();

        if (typeof showMoreFranchiseProjectsList === "function") {
          showMoreFranchiseProjectsList(moreBtn, frList);
        } else {
          frList.insertAdjacentHTML("beforeend", template);
        }

        $(".js-popup-geography").magnificPopup({
          type: "iframe",
          mainClass: "mfp-fade",
          removalDelay: 160,
          preloader: false,

          fixedContentPos: true,
        });

        initScrolls();

        if (mqlDesktop.matches) {
          let count = document.querySelectorAll(".js-list .item").length / 2;
          frList.setAttribute(
            "style",
            `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`
          );
        }
      });
  }

  if (document.querySelector(".vacancies")) {
    const accordionList = document.querySelectorAll(".js-top");

    accordionList.forEach((el) => {
      el.addEventListener("click", function (e) {
        let hideBlock = el.closest(".item").querySelector(".hide");
        e.preventDefault();
        $(hideBlock).slideToggle("slow", function () {
          el.classList.toggle("active");
        });
      });
    });

    const items = document.querySelectorAll(".js-item");

    const hiddenCity = document.querySelector(".js-city");

    items.forEach((element) => {
      let hideBlock = element.querySelector(".options");
      element.querySelector(".js-select").addEventListener("click", (e) => {
        e.preventDefault();
        $(hideBlock).slideToggle("fast", function () {
          element.classList.toggle("active");
        });
      });
      if (hideBlock.classList.contains("js-options-city")) {
        let options = hideBlock.querySelectorAll("a");
        options.forEach((el) => {
          el.addEventListener("click", function (e) {
            e.preventDefault();
            element.closest(".js-item").querySelector("span").innerHTML =
              el.innerHTML;
            hiddenCity.value = el.getAttribute("data-value");
            $(hideBlock).slideToggle("fast", function () {
              element.classList.toggle("active");
            });
          });
        });
      }
    });
  }

  if (document.querySelector("section.projects")) {
    var swiper = new Swiper(".swiper.projects__swiper", {
      spaceBetween: 50,
      slidesPerView: 1,
      speed: 500,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next.projects__next",
        prevEl: ".swiper-button-prev.projects__prev",
      },
    });
  }

  toastr.options = {
    closeButton: true,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-center",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  if (document.querySelector(".home-suggestions")) {
    const form = document.querySelector(".js-suggestions-form");

    const name = document.querySelector(".js-suggestions-name");
    const tel = document.querySelector(".js-suggestions-tel");
    const mail = document.querySelector(".js-suggestions-mail");

    const file = document.querySelector(".js-suggestions-file");
    const isName = document.querySelector(".js-suggestions-fileName");

    const submit = document.querySelector(".js-suggestions-submit");

    let nameResult = false;
    let telResult = false;
    let mailResult = false;
    let fileResult = false;

    name.addEventListener("input", function (e) {
      let result = e.target.value.length;

      name.style.borderColor = "green";
      nameResult = true;
      if (result <= 1) {
        name.style.borderColor = "red";
        nameResult = false;
      }
    });

    tel.addEventListener("input", function (e) {
      const maskOptions = {
        mask: "+7 (000)000-00-00",
        lazy: true,
      };
      const mask = new IMask(tel, maskOptions);

      let result = e.target.value.length;

      tel.style.borderColor = "green";
      telResult = true;
      if (result < 17) {
        tel.style.borderColor = "red";
        telResult = false;
      }
    });

    mail.addEventListener("input", function (e) {
      if (validateEmail(this.value)) {
        this.style.borderColor = "green";
        mailResult = true;
      } else {
        this.style.borderColor = "red";
        mailResult = false;
      }
    });

    const suggestionsFormCheck = function () {
      if (nameResult == false) {
        name.style.borderColor = "red";
      }
      if (telResult == false) {
        tel.style.borderColor = "red";
      }
      if (mailResult == false) {
        mail.style.borderColor = "red";
      }
      if (fileResult == false) {
        if (file) file.nextElementSibling.style.borderColor = "red";
      }
    };

    file.addEventListener("change", validateFile);

    function validateFile() {
      const allowedExtensions = ["docx", "pdf", "doc"],
        sizeLimit = 5000000; // 5 megabyte

      const { name: fileName, size: fileSize } = this.files[0];

      const fileExtension = fileName.split(".").pop();
      isName.innerHTML = fileName;
      file.nextElementSibling.style.borderColor = "green";
      fileResult = true;

      if (!allowedExtensions.includes(fileExtension)) {
        toastr.warning(`${file.getAttribute("data-formats")}`);
        isName.innerHTML = "Файл не выбран";
        if (file) file.nextElementSibling.style.borderColor = "red";
        fileResult = false;
        this.value = null;
      } else if (fileSize > sizeLimit) {
        toastr.warning(`${file.getAttribute("data-size")}`);
        isName.innerHTML = "Файл не выбран";
        if (file) file.nextElementSibling.style.borderColor = "red";
        fileResult = false;
        this.value = null;
      }
    }

    submit.addEventListener("click", function (e) {
      if (isStartSendForm) return;
      if (nameResult && telResult && mailResult) {
        // if (nameResult && telResult && mailResult && fileResult) {
        // раскоментировать
        if (typeof sendForm == "function") sendForm(form);

        // $(function () {
        //   'use strict';
        //   $(form).on('submit', function (e) {
        //     e.preventDefault();
        //     var fd = new FormData(this);
        //     console.log(fd)
        //     $.ajax({
        //       url: `${form.getAttribute('action')}`,
        //       type: 'POST',
        //       contentType: false,
        //       processData: false,
        //       data: fd,
        //       success: function (msg) {
        //         if (msg == 'ok') {
        //           console.log(msg, ' error');
        //           вывести сообщение ошибки сервера
        //           toastr.error(`${form.getAttribute('data-error')}`)

        //         } else {
        //           console.log(msg, ' success');
        //           toastr.success(`${form.getAttribute('data-success')}`);
        //           form.classList.add('success');
        //         }
        //       }
        //     });
        //   });
        // });

        // toastr.success(`${form.getAttribute('data-success')}`); //убрать
        // form.classList.add('success');
      } else {
        toastr.error(`${form.getAttribute("data-error")}`); //убрать
        suggestionsFormCheck(); //оставить
      }
    });
  }

  if (document.querySelector(".js-popup-form")) {
    $(".js-popup-form").magnificPopup({
      type: "ajax",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: true,
      callbacks: {
        ajaxContentAdded: function () {
          const form = document.querySelector(".js-form-popup-form");

          const name = document.querySelector(".js-form-popup-name");
          const tel = document.querySelector(".js-form-popup-tel");
          const mail = document.querySelector(".js-form-popup-mail");

          const file = document.querySelector(".js-form-popup-file");
          const isName = document.querySelector(".js-form-popup-fileName");

          const submit = document.querySelector(".js-form-popup-submit");

          let nameResult = false;
          let telResult = false;
          let mailResult = false;
          let fileResult = false;

          name.addEventListener("input", function (e) {
            let result = e.target.value.length;

            name.style.borderColor = "green";
            nameResult = true;
            if (result <= 1) {
              name.style.borderColor = "red";
              nameResult = false;
            }
          });

          tel.addEventListener("input", function (e) {
            const maskOptions = {
              mask: "+7 (000)000-00-00",
              lazy: true,
            };
            const mask = new IMask(tel, maskOptions);

            let result = e.target.value.length;

            tel.style.borderColor = "green";
            telResult = true;
            if (result < 17) {
              tel.style.borderColor = "red";
              telResult = false;
            }
          });

          mail.addEventListener("input", function (e) {
            if (validateEmail(this.value)) {
              this.style.borderColor = "green";
              mailResult = true;
            } else {
              this.style.borderColor = "red";
              mailResult = false;
            }
          });

          const popupFormCheck = function () {
            if (nameResult == false) {
              name.style.borderColor = "red";
            }
            if (telResult == false) {
              tel.style.borderColor = "red";
            }
            if (mailResult == false) {
              mail.style.borderColor = "red";
            }
            if (fileResult == false) {
              file.nextElementSibling.style.borderColor = "red";
            }
          };

          if (file) file.addEventListener("change", validateFile);

          function validateFile() {
            const allowedExtensions = ["docx", "pdf", "doc"],
              sizeLimit = 5000000; // 5 megabyte

            const { name: fileName, size: fileSize } = this.files[0];

            const fileExtension = fileName.split(".").pop();
            isName.innerHTML = fileName;
            file.nextElementSibling.style.borderColor = "green";
            fileResult = true;

            if (!allowedExtensions.includes(fileExtension)) {
              toastr.warning(`${file.getAttribute("data-formats")}`);
              isName.innerHTML = "Файл не выбран";
              file.nextElementSibling.style.borderColor = "red";
              fileResult = false;
              this.value = null;
            } else if (fileSize > sizeLimit) {
              toastr.warning(`${file.getAttribute("data-size")}`);
              isName.innerHTML = "Файл не выбран";
              file.nextElementSibling.style.borderColor = "red";
              fileResult = false;
              this.value = null;
            }
          }

          submit.addEventListener("click", function (e) {
            if (isStartSendForm) return;
            if (nameResult && telResult && mailResult) {
              // && fileResult

              // раскоментировать
              // $(function () {
              //   'use strict';
              //   $(form).on('submit', function (e) {
              //     e.preventDefault();
              //     var fd = new FormData(this);
              //     console.log(fd)
              //     $.ajax({
              //       url: `${form.getAttribute('action')}`,
              //       type: 'POST',
              //       contentType: false,
              //       processData: false,
              //       data: fd,
              //       success: function (msg) {
              //         if (msg == 'ok') {
              //           console.log(msg, ' error');
              //           вывести сообщение ошибки сервера
              //           toastr.error(`${form.getAttribute('data-error')}`)

              //         } else {
              //           console.log(msg, ' success');
              //           toastr.success(`${form.getAttribute('data-success')}`);
              //           $.magnificPopup.close();
              //         }
              //       }
              //     });
              //   });
              // });
              isStartSendForm = true;
              let nameAction = form.getAttribute("name");
              let formData = new FormData(form);
              formData.append("check", "nospam");
              let paramsAction = {
                mode: "class",
                data: formData,
              };
              BX.ajax
                .runComponentAction(
                  "custom:feedback",
                  "sendForm" + nameAction,
                  paramsAction
                )
                .then((response) => {
                  isStartSendForm = false;
                  if (response.status == "success") {
                    if (response.data.ERROR) {
                      console.log("Ошибка на форме");
                      toastr.error(`${form.getAttribute("data-error")}`);
                      return false;
                    }
                    form.classList.add("success");
                    $.magnificPopup.close();
                    toastr.success(`${form.getAttribute("data-success")}`);
                  }
                });
              //   toastr.success(`${form.getAttribute('data-success')}`); //убрать
              //   $.magnificPopup.close();
            } else {
              //   toastr.error(`${form.getAttribute('data-error')}`); //убрать
              popupFormCheck(); //оставить
            }
          });
        },
      },
    });
  }

  if (document.querySelector("section.cases")) {
    Scrollbar.init(document.querySelector(".js-scrollbar"), {
      overscrollEffect: "bounce",
      alwaysShowTracks: true,
    });
  }

  if (document.querySelector("section.vacancies")) {
    if (mqlDesktop.matches) {
      Scrollbar.init(document.querySelector(".js-scrollbar"), {
        overscrollEffect: "bounce",
        alwaysShowTracks: true,
      });
    }
  }

  // *********************************************
  if (document.querySelector(".vacancies .list")) {
    const itemList = document.querySelector(".vacancies .list");
    const moreBtn = document.querySelector(".js-more");

    // if (mqlDesktop.matches) {
    // 	let count = document.querySelectorAll('.news__list li').length / 2;
    // 	itemList.setAttribute('style', `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`);
    // }

    moreBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (typeof showMoreVacancyList === "function") {
        showMoreVacancyList(moreBtn, itemList);
      } else {
      }
    });
  }

  if (mqlDesktop.matches) {
    if (document.querySelector(".js-set-line")) {
      let list = document.querySelector(".js-set-line");
      let items = list.querySelectorAll("li");
      list.setAttribute(
        "style",
        `grid-template-columns: repeat(${Math.round(items.length)}, 1fr)`
      );
      document.querySelector(".js-line-content").style.paddingTop = `${
        document.querySelector(".js-line-preview").getBoundingClientRect()
          .height
      }px`;
    }

    if (document.querySelector(".js-company-line")) {
      let list = document.querySelector(".js-company-line");
      let items = list.querySelectorAll("li");
      list.setAttribute(
        "style",
        `grid-template-columns: repeat(${Math.round(items.length)}, 1fr)`
      );
      document.querySelector(".js-swiper-for-line").style.width = `${
        list.getBoundingClientRect().width
      }px`;
    }

    if (document.querySelector(".services-text-line")) {
      let list = document.querySelector(".services-text-line");
      let items = list.querySelectorAll("p");
      list.setAttribute(
        "style",
        `grid-template-columns: repeat(${Math.round(items.length)}, 1fr)`
      );
      list.style.paddingTop = `${
        document.querySelector(".js-services-preview").getBoundingClientRect()
          .height
      }px`;
      list.style.opacity = "1";
    }
  }

  // glitch slider-team with p5.js

  // let canvWidth;
  // let canvHeight;
  // let cnv;
  // let isLoaded = false;
  // let glitchElement;
  // let imgCanvas;
  // let imgSrc;
  // let imgBefore;
  // let sketchInstance;
  // let showEffect;
  // let bgColor;
  // const animSliders = document.querySelectorAll(".home-team__swiper");

  // const checkVisible = (animatedElements, cb) => {
  //   if (
  //     "IntersectionObserver" in window &&
  //     "IntersectionObserverEntry" in window &&
  //     "intersectionRatio" in window.IntersectionObserverEntry.prototype
  //   ) {
  //     const IO = new IntersectionObserver(
  //       // eslint-disable-next-line
  //       function (entries, IO) {
  //         entries.forEach((entry) => {
  //           if (!entry.isIntersecting) {
  //             // eslint-disable-next-line
  //             return;
  //             // eslint-disable-next-line
  //           } else {
  //             // entry.target.classList.add(className);
  //             cb();
  //             IO.unobserve(entry.target);
  //           }
  //         });
  //       },
  //       { threshold: [0.25, 0.75] }
  //     );

  //     animatedElements.forEach((elem) => {
  //       IO.observe(elem);
  //     });
  //   }
  // };

  // function getElements() {
  //   glitchElement = document.querySelector(
  //     ".home-team__swiper .swiper-slide-active .image .image-glitch"
  //   );
  //   if (
  //     glitchElement &&
  //     glitchElement.querySelector("img") &&
  //     document.querySelector(".home-team__swiper .swiper-slide-active .image")
  //   ) {
  //     canvWidth = parseFloat(
  //       window
  //         .getComputedStyle(
  //           document.querySelector(
  //             ".home-team__swiper .swiper-slide-active .image"
  //           )
  //         )
  //         .getPropertyValue("width")
  //     );
  //     canvHeight = parseFloat(
  //       window
  //         .getComputedStyle(
  //           document.querySelector(
  //             ".home-team__swiper .swiper-slide-active .image"
  //           )
  //         )
  //         .getPropertyValue("height")
  //     );
  //     imgBefore = glitchElement.querySelector("img");
  //     imgSrc = glitchElement.querySelector("img").getAttribute("src");
  //     bgColor = document
  //       .querySelector(".home-team__swiper .swiper-slide-active .image")
  //       .getAttribute("data-bg");
  //     showEffect = setTimeout(() => {
  //       const btnNext = document.querySelectorAll(
  //         ".home-team__swiper .home-team__next"
  //       );
  //       const btnPrev = document.querySelectorAll(
  //         ".home-team__swiper .home-team__prev"
  //       );
  //       // btnNext.forEach(item => {
  //       // 	item.addEventListener('click', clearTimeout(showEffect));
  //       // });
  //       // btnPrev.forEach(item => {
  //       // 	item.addEventListener('click', clearTimeout(showEffect));
  //       // });
  //       glitchEffect();
  //     }, 1000);
  //   }
  // }

  // function glitchEffect() {
  //   imgBefore.remove();
  //   const sketch = (s) => {
  //     s.setup = () => {
  //       s.background(bgColor);
  //       cnv = s.createCanvas(canvWidth, canvHeight);
  //       cnv.parent(glitchElement);
  //       imgCanvas = s.loadImage(imgSrc, function (img) {
  //         isLoaded = true;
  //       });
  //     };

  //     s.draw = () => {
  //       s.clear();
  //       s.background(0);
  //       s.image(imgCanvas, 0, 0);

  //       const channelLen = 4;
  //       let imgOrigin = imgCanvas;
  //       imgOrigin.loadPixels();
  //       let copyData = [];
  //       let flowLineImgs = [];
  //       let shiftLineImgs = [];
  //       let shiftRGBs = [];
  //       let scatImgs = [];
  //       let throughFlag = true;
  //       copyData = new Uint8ClampedArray(imgOrigin.pixels);

  //       // flow line
  //       for (let i = 0; i < 1; i++) {
  //         let o = {
  //           pixels: null,
  //           t1: s.floor(s.random(0, 1000)),
  //           speed: s.floor(s.random(4, 24)),
  //           randX: s.floor(s.random(24, 80)),
  //         };
  //         flowLineImgs.push(o);
  //       }

  //       // shift line
  //       for (let i = 0; i < 6; i++) {
  //         let o = null;
  //         shiftLineImgs.push(o);
  //       }

  //       // shift RGB
  //       for (let i = 0; i < 1; i++) {
  //         let o = null;
  //         shiftRGBs.push(o);
  //       }

  //       // scat imgs
  //       for (let i = 0; i < 3; i++) {
  //         let scatImg = {
  //           img: null,
  //           x: 0,
  //           y: 0,
  //         };
  //         scatImgs.push(scatImg);
  //       }

  //       function replaceData(destImg, srcPixels) {
  //         for (let y = 0; y < destImg.height; y++) {
  //           for (let x = 0; x < destImg.width; x++) {
  //             let r, g, b, a;
  //             let index;
  //             index = (y * destImg.width + x) * channelLen;
  //             r = index;
  //             g = index + 1;
  //             b = index + 2;
  //             a = index + 3;
  //             destImg.pixels[r] = srcPixels[r];
  //             destImg.pixels[g] = srcPixels[g];
  //             destImg.pixels[b] = srcPixels[b];
  //             destImg.pixels[a] = srcPixels[a];
  //           }
  //         }
  //         destImg.updatePixels();
  //       }

  //       function flowLine(srcImg, obj) {
  //         let destPixels, tempY;
  //         destPixels = new Uint8ClampedArray(srcImg.pixels);
  //         obj.t1 %= srcImg.height;
  //         obj.t1 += obj.speed;
  //         //tempY = floor(noise(obj.t1) * srcImg.height);
  //         tempY = s.floor(obj.t1);
  //         for (let y = 0; y < srcImg.height; y++) {
  //           if (tempY === y) {
  //             for (let x = 0; x < srcImg.width; x++) {
  //               let r, g, b, a;
  //               let index;
  //               index = (y * srcImg.width + x) * channelLen;
  //               r = index;
  //               g = index + 1;
  //               b = index + 2;
  //               a = index + 3;
  //               destPixels[r] = srcImg.pixels[r] + obj.randX;
  //               destPixels[g] = srcImg.pixels[g] + obj.randX;
  //               destPixels[b] = srcImg.pixels[b] + obj.randX;
  //               destPixels[a] = srcImg.pixels[a];
  //             }
  //           }
  //         }
  //         return destPixels;
  //       }

  //       function shiftLine(srcImg) {
  //         let offsetX;
  //         let rangeMin, rangeMax;
  //         let destPixels;
  //         let rangeH;

  //         destPixels = new Uint8ClampedArray(srcImg.pixels);
  //         rangeH = srcImg.height;
  //         rangeMin = s.floor(s.random(0, rangeH));
  //         rangeMax = rangeMin + s.floor(s.random(1, rangeH - rangeMin));
  //         offsetX = channelLen * s.floor(s.random(-40, 40));

  //         for (let y = 0; y < srcImg.height; y++) {
  //           if (y > rangeMin && y < rangeMax) {
  //             for (let x = 0; x < srcImg.width; x++) {
  //               let r, g, b, a;
  //               let r2, g2, b2, a2;
  //               let index;

  //               index = (y * srcImg.width + x) * channelLen;
  //               r = index;
  //               g = index + 1;
  //               b = index + 2;
  //               a = index + 3;
  //               r2 = r + offsetX;
  //               g2 = g + offsetX;
  //               b2 = b + offsetX;
  //               destPixels[r] = srcImg.pixels[r2];
  //               destPixels[g] = srcImg.pixels[g2];
  //               destPixels[b] = srcImg.pixels[b2];
  //               destPixels[a] = srcImg.pixels[a];
  //             }
  //           }
  //         }
  //         return destPixels;
  //       }

  //       function shiftRGB(srcImg) {
  //         let randR, randG, randB;
  //         let destPixels;
  //         let range;

  //         range = 16;
  //         destPixels = new Uint8ClampedArray(srcImg.pixels);
  //         randR =
  //           (s.floor(s.random(-range, range)) * srcImg.width +
  //             s.floor(s.random(-range, range))) *
  //           channelLen;
  //         randG =
  //           (s.floor(s.random(-range, range)) * srcImg.width +
  //             s.floor(s.random(-range, range))) *
  //           channelLen;
  //         randB =
  //           (s.floor(s.random(-range, range)) * srcImg.width +
  //             s.floor(s.random(-range, range))) *
  //           channelLen;

  //         for (let y = 0; y < srcImg.height; y++) {
  //           for (let x = 0; x < srcImg.width; x++) {
  //             let r, g, b, a;
  //             let r2, g2, b2, a2;
  //             let index;

  //             index = (y * srcImg.width + x) * channelLen;
  //             r = index;
  //             g = index + 1;
  //             b = index + 2;
  //             a = index + 3;
  //             r2 = (r + randR) % srcImg.pixels.length;
  //             g2 = (g + randG) % srcImg.pixels.length;
  //             b2 = (b + randB) % srcImg.pixels.length;
  //             destPixels[r] = srcImg.pixels[r2];
  //             destPixels[g] = srcImg.pixels[g2];
  //             destPixels[b] = srcImg.pixels[b2];
  //             destPixels[a] = srcImg.pixels[a];
  //           }
  //         }

  //         return destPixels;
  //       }

  //       function getRandomRectImg(srcImg) {
  //         let startX;
  //         let startY;
  //         let rectW;
  //         let rectH;
  //         let destImg;
  //         startX = s.floor(s.random(0, srcImg.width - 30));
  //         startY = s.floor(s.random(0, srcImg.height - 50));
  //         rectW = s.floor(s.random(30, srcImg.width - startX));
  //         rectH = s.floor(s.random(1, 50));
  //         destImg = srcImg.get(startX, startY, rectW, rectH);
  //         destImg.loadPixels();
  //         return destImg;
  //       }

  //       function show() {
  //         // restore the original state
  //         replaceData(imgOrigin, copyData);

  //         // sometimes pass without effect processing
  //         let n = s.floor(s.random(100));

  //         if (n > 75 && throughFlag) {
  //           this.throughFlag = false;
  //           setTimeout(() => {
  //             this.throughFlag = true;
  //           }, Math.floor(Math.random(40, 400)));
  //         }

  //         if (!throughFlag) {
  //           sketchInstance.push();
  //           sketchInstance.translate(
  //             (width - this.imgOrigin.width) / 2,
  //             (height - this.imgOrigin.height) / 2
  //           );
  //           image(this.imgOrigin, 0, 0);
  //           pop();
  //           return;
  //         }

  //         // flow line
  //         flowLineImgs.forEach((v, i, arr) => {
  //           arr[i].pixels = flowLine(imgOrigin, v);
  //           if (arr[i].pixels) {
  //             replaceData(imgOrigin, arr[i].pixels);
  //           }
  //         });

  //         // shift line
  //         shiftLineImgs.forEach((v, i, arr) => {
  //           if (s.floor(s.random(100)) > 50) {
  //             arr[i] = shiftLine(imgOrigin);
  //             replaceData(imgOrigin, arr[i]);
  //           } else {
  //             if (arr[i]) {
  //               replaceData(imgOrigin, arr[i]);
  //             }
  //           }
  //         });

  //         // shift rgb
  //         shiftRGBs.forEach((v, i, arr) => {
  //           if (s.floor(s.random(100)) > 65) {
  //             arr[i] = shiftRGB(imgOrigin);
  //             replaceData(imgOrigin, arr[i]);
  //           }
  //         });

  //         s.push();
  //         s.translate(
  //           (s.width - imgOrigin.width) / 2,
  //           (s.height - imgOrigin.height) / 2
  //         );
  //         s.image(imgOrigin, 0, 0);
  //         s.pop();

  //         // scat image
  //         scatImgs.forEach((obj) => {
  //           s.push();
  //           s.translate(
  //             (s.width - imgOrigin.width) / 2,
  //             (s.height - imgOrigin.height) / 2
  //           );
  //           if (s.floor(s.random(100)) > 80) {
  //             obj.x = s.floor(
  //               s.random(-imgOrigin.width * 0.3, imgOrigin.width * 0.7)
  //             );
  //             obj.y = s.floor(
  //               s.random(-imgOrigin.height * 0.1, imgOrigin.height)
  //             );
  //             obj.img = getRandomRectImg(imgOrigin);
  //           }
  //           if (obj.img) {
  //             s.image(obj.img, obj.x, obj.y);
  //           }
  //           s.pop();
  //         });
  //       }

  //       if (isLoaded) {
  //         show();
  //       }
  //     };
  //   };

  //   sketchInstance = new p5(sketch);

  //   function resetBackground() {
  //     isLoaded = false;
  //     sketchInstance.clear();
  //     // sketchInstance.background(bgColor);
  //     imgCanvas = sketchInstance.loadImage(imgSrc, function (img) {
  //       isLoaded = true;
  //     });
  //     sketchInstance.image(imgCanvas, 0, 0);
  //   }

  //   const period = setInterval(resetBackground, 340);

  //   const time = setTimeout(() => {
  //     clearInterval(period);
  //     isLoaded = false;
  //     sketchInstance.clear();
  //     // sketchInstance.background(bgColor);
  //     imgCanvas = sketchInstance.loadImage(imgSrc, function (img) {});
  //     sketchInstance.image(imgCanvas, 0, 0);
  //   }, 620);

  //   const allTime = setTimeout(() => {
  //     setTimeout(() => {
  //       glitchElement.classList.add("hide");
  //       document
  //         .querySelector(
  //           ".home-team__swiper .swiper-slide-active .image picture"
  //         )
  //         .classList.add("show");
  //     }, 400);

  //     const period1 = setInterval(resetBackground, 400);
  //     const time1 = setTimeout(() => {
  //       sketchInstance.tint(255, 160);
  //       clearInterval(period1);
  //       isLoaded = false;
  //       sketchInstance.clear();
  //       // sketchInstance.background(bgColor);
  //       imgCanvas = sketchInstance.loadImage(imgSrc, function (img) {});
  //       sketchInstance.image(imgCanvas, 0, 0);
  //       sketchInstance.remove();
  //     }, 620);
  //   }, 680);
  // }

  // if (swiperTeam && animSliders[0]) {
  //   checkVisible(animSliders, getElements);
  //   swiperTeam.on("transitionEnd", function () {
  //     getElements();
  //   });
  //   swiperTeam.on("click", function () {
  //     if (showEffect) clearTimeout(showEffect);
  //   });
  // }

  //glitch effect with anim css

  let glitchElement;
  const animSliders = document.querySelectorAll(".home-team__swiper");
  let animationDelay;

  if (
    mqlmobile.matches &&
    document.querySelectorAll(".home-team__swiper .image-glitch")[0]
  ) {
    document
      .querySelectorAll(".home-team__swiper .image-glitch")
      .forEach((item) => {
        item.remove();
      });
  }

  const checkVisible = (animatedElements, cb) => {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      const IO = new IntersectionObserver(
        // eslint-disable-next-line
        function (entries, IO) {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              // eslint-disable-next-line
              return;
              // eslint-disable-next-line
            } else {          
              animationDelay = setTimeout(() => {
                cb();
              }, 1500);
              IO.unobserve(entry.target);
            }
          });
        },
        { threshold: [0.25, 0.75] }
      );

      animatedElements.forEach((elem) => {
        IO.observe(elem);
      });
    }
  };

  function getElements() {
    glitchElement = document.querySelector(
      ".home-team__swiper .swiper-slide-active .image-glitch"
    );
    if (
      glitchElement &&
      glitchElement.querySelector("img") &&
      document.querySelector(".home-team__swiper .swiper-slide-active .image")
    ) {
      imgBefore = glitchElement.querySelector("img");
      showEffect = setTimeout(() => {
        glitchEffect();
      }, 1700);
    }
  }

  if (swiperTeam && animSliders[0]) {
    checkVisible(animSliders, getElements);
    swiperTeam.on("transitionEnd", function () {
      getElements();
    });
  }

  function glitchEffect() {
    glitchElement.classList.add("hide");
    document
      .querySelector(".home-team__swiper .swiper-slide-active .image picture")
      .classList.add("show");
  }
  clearTimeout(animationDelay);
});
